export default __webpack_public_path__ + "static/media/adrien-olichon-RCAhiGJsUUE-unsplash.fc2b50ec.jpg";